"use client";

import { ArrowRight, Plus, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What areas do you serve for mold testing?",
  answer: "We provide comprehensive environmental testing and mold inspection services across Dade, Broward, and West Palm Beach counties. Our team is fully mobile and equipped to handle residential and commercial properties throughout South Florida."
}, {
  question: "How quickly can you schedule an inspection?",
  answer: "We prioritize urgent environmental concerns. In most cases, we can schedule your inspection within 24 to 48 hours. For emergency situations, please call (561) 560-MOLD (6653) directly to discuss our immediate availability."
}, {
  question: "Are your inspectors licensed and certified?",
  answer: "Yes. MYB Services maintains all required state licenses and industry certifications. Our 26 years of experience ensure that every inspection is conducted with clinical precision and adherence to the highest safety standards."
}, {
  question: "What does a typical mold inspection include?",
  answer: "Our process includes a visual assessment, moisture mapping, and professional air or surface sampling. We provide a detailed, evidence-based report that identifies the source of the issue and outlines the necessary steps for remediation."
}, {
  question: "Do you perform mold remediation services?",
  answer: "We specialize in independent, third-party environmental testing. By remaining neutral, we ensure our findings are unbiased and focused solely on your health and property safety. We can provide referrals to trusted, certified remediation partners if needed."
}, {
  question: "How long does it take to get results?",
  answer: "Once samples are collected, they are processed in a certified laboratory. You will typically receive your comprehensive, easy-to-understand results within 3 to 5 business days, depending on the complexity of the analysis."
}, {
  question: "Is mold testing covered by insurance?",
  answer: "Coverage varies by policy. We recommend contacting your insurance provider to inquire about environmental testing coverage. We provide all necessary documentation and professional reports to assist you in your claims process."
}, {
  question: "Why choose MYB Services?",
  answer: "With 26 years of dedicated service, we combine clinical expertise with local knowledge. Our commitment to evidence-forward testing and transparent communication has made us the trusted choice for property owners across South Florida."
}];
export default function Inquiries() {
  return <section data-section-id="4087" id="common-inquiries" className="bg-background py-24">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32">
              <p className="font-mono text-xs uppercase tracking-widest text-primary mb-8">
                Inquiries
              </p>
              <h2 className="font-default text-4xl md:text-5xl lg:text-[56px] leading-[1.05] text-foreground mb-8">
                Common{" "}
                <span className="block italic font-light text-primary">
                  questions.
                </span>
              </h2>
              <p className="font-default text-[17px] leading-relaxed text-muted-foreground max-w-md mb-8">
                If your question remains unanswered, please contact our office directly at{" "}
                <span className="text-foreground">(561) 560-MOLD (6653)</span>.
              </p>
              <Link to="/ContactPage" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-primary hover:text-blue-800 transition-colors duration-300 border-b border-primary/30 hover:border-primary pb-1">
                Contact our team
                <ArrowRight className="size-3" />
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-8 lg:col-start-6">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="border-b border-border last:border-b-0 group">
                  <AccordionTrigger className="hover:no-underline py-8 [&>svg]:hidden">
                    <span className="font-default text-xl md:text-[22px] leading-snug text-foreground text-left pr-6 group-hover:text-primary transition-colors duration-300">
                      {faq.question}
                    </span>
                    <span className="relative flex items-center justify-center size-8 rounded-lg border border-border text-foreground shrink-0 transition-all duration-[400ms] group-hover:border-primary group-hover:text-primary">
                      <Plus className="size-4 absolute transition-all duration-[400ms] group-data-[state=open]:rotate-90 group-data-[state=open]:opacity-0" strokeWidth={1} />
                      <X className="size-4 absolute transition-all duration-[400ms] rotate-[-90deg] opacity-0 group-data-[state=open]:rotate-0 group-data-[state=open]:opacity-100" strokeWidth={1} />
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="pb-8 pr-12">
                    <p className="font-default text-[17px] text-muted-foreground max-w-[560px]" style={{
                  lineHeight: "1.65"
                }}>
                      {faq.answer}
                    </p>
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}